import { useContext } from "react";
import { StepperContext } from "@/context";
import type { StepperContextValue } from "@/context";

/**
 * @returns {{
 * activeStep: Number,
 * moveNext: () => void
 * moveBack: () => void
 * hasNext: () => Boolean
 * moveStart: () => void
 * }}
 */
export const useStepperContext = (): StepperContextValue =>
  useContext(StepperContext) as StepperContextValue;
